import { render, staticRenderFns } from "./GameThumbnail.vue?vue&type=template&id=4c5d66e4&"
import script from "./GameThumbnail.vue?vue&type=script&lang=js&"
export * from "./GameThumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports